import React, {useContext} from "react";
import "./Achievement.scss";
import AchievementCard from "../../components/achievementCard/AchievementCard";
import {achievementSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";



export default function Achievement() {
  const {isDark} = useContext(StyleContext);
  if (!achievementSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      
      <div className="main row" id="achievements">
        <div className="col-lg-12 col-md-12 col-12">
        <div className="achievement-header ">
            <h1
              className={
                isDark
                  ? "dark-mode heading achievement-heading fw-bold"
                  : "heading achievement-heading fw-bold"
              }
            >
              {achievementSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle achievement-subtitle"
                  : "subTitle achievement-subtitle"
              }
            >
              {achievementSection.subtitle}
            </p>
          </div>
        </div>
        {/* <div className="achievement-main-div col-12 d-flex  "> */}
          <div className="achievement-cards-div ">
            {achievementSection.achievementsCards.map((card, i) => {
              return (
                <AchievementCard
                 className=" col-lg-12 col-md-6 col-12  "
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: card.title,
                    description: card.subtitle,
                    image: card.image,
                    imageAlt: card.imageAlt,
                    footer: card.footerLink
                  }}
                />
              );
            })}
          </div>
        {/* </div> */}
      </div>
    </Fade>
  );
}
